import axios from "../axiosInstance";
import { GetCompanyOfferingAccessResponse } from "../getCompanyOfferingAccess/types";

export interface SetSubscriptionAccessOverrideDTO {
  forceActive: boolean;
  reason?: string | null;
  /** ISO-8601 datetime; null/omitted = no expiry. */
  expiresAt?: string | null;
}

/**
 * Set/update the access override for a (company, offering). The backend
 * recomputes effective access immediately and returns the refreshed
 * per-offering overview.
 */
export const setSubscriptionAccessOverride = async (
  companyUuid: string,
  offeringCode: string,
  dto: SetSubscriptionAccessOverrideDTO,
): Promise<GetCompanyOfferingAccessResponse> => {
  const response = await axios.put<GetCompanyOfferingAccessResponse>(
    `/api/private/companies/${companyUuid}/offering-access/${offeringCode}/override`,
    dto,
  );
  return response.data;
};

/** Clear the override and recompute. Returns the refreshed overview. */
export const clearSubscriptionAccessOverride = async (
  companyUuid: string,
  offeringCode: string,
): Promise<GetCompanyOfferingAccessResponse> => {
  const response = await axios.delete<GetCompanyOfferingAccessResponse>(
    `/api/private/companies/${companyUuid}/offering-access/${offeringCode}/override`,
  );
  return response.data;
};
